/**
 * @typedef {Object} CommandGroup
 * @property {string=} id
 * @property {string=} name
 */

/**
 * @typedef {Object} CommandGroupService
 * @property {function(?string): angular.IPromise<CommandGroup[]>} query
 * @property {function(?string): angular.IPromise<CommandGroup>} get
 * @property {function(string): angular.IPromise<CommandGroup>} delete
 * @property {function(CommandGroup): angular.IPromise<CommandGroup>} post
 * @property {function(string, CommandGroup): angular.IPromise<CommandGroup>} patch
 */

const mod = require('../bahabot.module.js')

/**
 * @param {angular.resource.IResourceService} $resource
 * @param {angular.IQService} $q
 * @returns {CommandService}
 */
function bahabotCommandGroupFactory($resource, $q) {
    const CommandGroups = $resource('/api/protected/command-groups/:id', {
        'id': '@id'
    }, {
        patch: { method: 'PATCH' },
    });

    return CommandGroups;
}

mod.factory('CommandGroupService', ["$resource", bahabotCommandGroupFactory]);
